import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BankingService } from '../../features/banking/services/banking.service';

@Component({
  selector: 'app-update-banking-details',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatSelectModule,
    MatTabsModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
  ],
  templateUrl: './update-transaction.component.html',
  styleUrl: './banking-details.component.scss',
})
export class UpdateBankingDetailsComponent {
  @Input() transactionDetail: any;
  @Output() transactionUpdated = new EventEmitter<any>();
  bankId: number;
  categorizeForm: FormGroup;
  flow: string;
  categories: any;
  selectedCategoryId: any;

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['transactionDetail'] &&
      changes['transactionDetail'].currentValue
    ) {
      console.log('transactionDetail updated:', this.transactionDetail);
      this.patchValue();
    }
  }

  constructor(
    private route: ActivatedRoute,
    private bankingService: BankingService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    console.log('transactionData', this.transactionDetail);
    this.getTransactionCategories();
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.bankId = Number(id);
      this.initForm();
    }
  }

  initForm() {
    this.categorizeForm = this.fb.group({
      category: [
        this.transactionDetail?.transactionCategory,
        Validators.required,
      ],
      date: [this.transactionDetail?.date || '', Validators.required],
      amount: [this.transactionDetail?.amount || 0, Validators.required],
      reference: [this.transactionDetail?.referenceNumber || ''],
      description: [this.transactionDetail?.description || ''],
    });

    console.log('this.categorizeForm ini', this.categorizeForm.value);
  }

  patchValue() {
    console.log('transactionDetail', this.transactionDetail);
    const matchedCategory = this.categories.find(
      (c: string) => c.toLowerCase() === this.transactionDetail?.transactionCategory?.toLowerCase()
    );
    
    this.categorizeForm.patchValue({
      category: matchedCategory || null, // ensure it's one of the options
      date: new Date(parseInt(this.transactionDetail.date.toString(), 10)),
      amount: this.transactionDetail?.amount,
      reference: this.transactionDetail?.referenceNumber,
      description: this.transactionDetail?.description,
    });

    console.log('this.categorizeForm', this.categorizeForm.value);
  }

  getTransactionCategories() {
    this.bankingService.transactionCategories('').subscribe({
      next: (res) => {
        this.categories = res;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  selectionChangeCategory(event: any) {
    const selectedCategory = event.value; // This contains the selected category object
    console.log(selectedCategory);

    if (selectedCategory.categoryStatus === 'Out') {
      this.flow = 'Debit';
    } else if (selectedCategory.categoryStatus === 'In') {
      this.flow = 'Credit';
    }
    (this.selectedCategoryId = selectedCategory.id),
      console.log('Selected category flow:', selectedCategory.categoryStatus);
    console.log('Selected category id:', selectedCategory.id);
  }

  onUpdate() {
    const id = Number(this.transactionDetail?.id);
    const updateBankTransactionInput = {
      id: Number(this.transactionDetail?.id),
      bankAccountId: Number(this.transactionDetail?.bankAccountId),
      transactionType: this.transactionDetail?.transactionType,
      amount: Number(this.categorizeForm.value.amount),
      transactionDate: this.datePipe.transform(
        this.categorizeForm.value.date,
        'yyyy-MM-dd'
      ),
      description: this.categorizeForm.value.description,
      referenceNumber: this.categorizeForm.value.reference,
    };
    this.bankingService
      .updateBankTransaction(id, updateBankTransactionInput)
      .subscribe({
        next: (data) => {
          this.transactionUpdated.emit();
          this.toastr.success('Transaction updated successfully', 'Success');
        },
        error: (error) => {
          this.toastr.error(error, 'Error');
        },
      });
  }
}
